<template>
	<div class="order-page">

		<div class="top-tabs flex">
			<div class="tab" :class="tabActive == 1 ? 'active' : ''" @click="changeTab(1)">
				{{$t(`allOrder.tab1_${tabIndex}`)}}({{dataTotal}})
			</div>
			<div class="tab" :class="tabActive == 2 ? 'active' : ''" @click="changeTab(2)">
				{{$t(`allOrder.tab2_${tabIndex}`)}}
			</div>
			<div class="tab" :class="tabActive == 3 ? 'active' : ''" @click="changeTab(3)" >
				{{$t(`allOrder.tab3_${tabIndex}`)}}
			</div>
		</div>

		<!-- <div class="search-form flex-center-start">
      <div class="form-item flex-center-start">
        <div class="label">{{ $t('jiao-yi-bi-zhong') }}</div>
        <div class="input border">
          <a-select v-model="form.bitName"  dropdownClassName="full-select" class="hide-border" :placeholder="$t('qing-xuan-ze-2')">
            <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
            <a-select-option v-for="(option, index) in bitList" :key="index" :value="option.ID" >
              {{option.ShortName}}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="form-item flex-center-start">
        <div class="label">{{ $t('jiao-yi-fang-xiang') }}</div>
        <div class="input border">
          <a-select v-model="form.tradeType"  dropdownClassName="full-select" class="hide-border" :placeholder="$t('qing-xuan-ze-3')">
            <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
            <a-select-option v-for="(option, index) in tradeFunList" :key="index" :value="option.value" >
              {{option.label}}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="form-item flex-center-start">
        <div class="label">{{ $t('chart_page.time') }}</div>
        <div class="input long flex-center">
          <a-date-picker  v-model="form.startTime"></a-date-picker>
          <span class="space">{{ $t('zhi') }}</span>
          <a-date-picker   v-model="form.endTime"></a-date-picker>
        </div>
      </div>
    </div> -->

		<template v-if="tabActive != 3">

			<!--合约-->
			<div class="list-table clear-bg mini" v-if="tabIndex == 3">
				<div class="th-line flex-center-between">
					<div class="th flex-1">{{ $t('jiao-yi-bi-zhong-fang-xiang') }}</div>
					<div class="th flex-1">{{ $t('lei-xing') }}</div>
					<div class="th flex-2">{{ $t('bao-zheng-jin-jiao-yi-shi-jian') }}</div>
					<div class="th flex-2">{{ $t('kai-cang-jia-ge-chi-cang-liang') }}</div>
					<div class="th flex-2">{{ $t('biao-ji-jia-ge-shou-yi') }}</div>
					<div class="th flex-1">{{ $t('yu-ji-qiang-ping-cang') }}</div>
					<div class="th action long">{{ $t('cao-zuo-1') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in orderList" :key="i" >
						<div class="td flex-1 flex-center-start">
							<img :src="'/upload/' + item.Currency.Logo" alt="">
							<span>{{item.Currency.ShortName}}</span>
							<span class="line"></span>
							<span class="tab" :class="item.Direction == 'long' ? 'green' : 'red'">{{item.Direction == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}</span>
						</div>
						<div class="td flex-1">{{item.Full == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{item.Multiple}}X</div>
						<div class="td flex-2">
							<span>{{parseFloat(item.Margin).toFixed(4)}}</span>
							<span class="line"></span>
							<span>{{item.CreatedAt}}</span>
						</div>
						<div class="td flex-2">
							<span>{{parseFloat(item.OpenClose).toFixed(4)}}</span>
							<span class="line"></span>
							<span>{{item.OpenNum}}</span>
						</div>
						<div class="td flex-2">
							<span>{{parseFloat(item.TrustClose).toFixed(4)}}</span>
							<span class="line"></span>
							<span>{{parseFloat(item.Profit).toFixed(4)}}</span>
						</div>
						<div class="td flex-1">{{getContractClose(item.OpenClose, item.Multiple, item.Direction)}}</div>
						<div class="td action long flex-center">
							<div class="btn " @click.stop="setWinOrLose(item)">{{$t('trade.label11')}}</div>
							<div class="btn" @click.stop="toClearOrder(item)">{{i18n.t('trade.status5')}}</div>
						</div>
					</div>
				</div>
			</div>

			<!--期权-->
			<div class="list-table clear-bg mini" v-if="tabIndex == 2 || tabIndex == 4">
				<div class="th-line flex-center-between">
					<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-fang-xiang-0') }}</div>
					<div class="th flex-2">{{ $t('mai-ru-jineusdt') }}</div>
					<div class="th flex-2">{{ $t('kai-cang-jia-ge-shi-jian') }}</div>
					<div class="th flex-2">{{ $t('jiao-ge-jia-ge-shi-jian') }}</div>
					<div class="th flex-2">{{ $t('ying-kui-usdt') }}</div>
					<div class="th action">{{ $t('finance.label12') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in orderList" :key="i" >
						<div class="td flex-2 flex-center-start">
							<img :src="'/upload/' + item.Currency.Logo" alt="">
							<span>{{item.Currency.ShortName}}</span>
							<span class="line"></span>
							<span class="tab" :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? i18n.t('trade.buy3') : i18n.t('trade.sell3')}}</span>
						</div>
						<div class="td flex-2">{{item.Amount}}</div>
						<div class="td flex-2">
							<span>{{parseFloat(item.MarkPrice).toFixed(4)}}</span>
							<span class="line"></span>
							<span>{{item.CreatedAt}}</span>
						</div>
						<div class="td flex-2">
							<span>{{parseFloat(item.SettlementPrice).toFixed(4)}}</span>
							<span class="line"></span>
							<span>
								<template v-if="item.Status == 0">{{getCountdownTime(item)}}</template>
								<template v-else>{{item.SettlementTime}}</template>
							</span>
						</div>
						<div class="td flex-2">{{parseFloat(item.Profit).toFixed(4)}}</div>
						<div class="td action flex-center">
							{{item.Status == 0 ? i18n.t('trade.status6') : (item.Status == 1 ? i18n.t('trade.status7') : i18n.t('trade.status8'))}}
						</div>
					</div>
				</div>
			</div>

			<!--现货-->
			<div class="list-table clear-bg mini" v-if="tabIndex == 1">
				<div class="th-line flex-center-between">
					<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-fang-xiang-1') }}</div>
					<div class="th flex-2">{{ $t('wei-tuo-lei-xing') }}</div>
					<div class="th flex-2">{{ $t('wei-tuo-shi-jian') }}</div>
					<div class="th flex-2">{{ $t('wei-tuo-shu-liang') }}</div>
					<div class="th flex-2">{{ $t('wei-tuo-jia-ge') }}</div>
					<div class="th flex-1">{{ $t('zhuang-tai') }}</div>
					<div class="th action">{{ $t('cao-zuo-1') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in orderList" :key="i" >
						<div class="td flex-2 flex-center-start">
							<img :src="'/upload/' + item.Currency.Logo" alt="">
							<span>{{item.Currency.ShortName}}</span>
							<span class="line"></span>
							<span class="tab" :class="item.Trade == 'buy' ? 'green' : 'red'">{{item.Trade == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}</span>
						</div>
						<div class="td flex-2">{{item.Trust == 'limit' ? i18n.t('trade.label53') : i18n.t('trade.label52')}}</div>
						<div class="td flex-2">
							<span>{{item.CreatedAt}}</span>
						</div>
						<div class="td flex-2">
							<span>{{item.TrustNum}}</span>
						</div>
						<div class="td flex-2">{{parseFloat(item.Close).toFixed(4)}}</div>
						<div class="td flex-1">{{$t(`trade.status${item.Status + 1}`)}}</div>
						<div class="td action flex-center">
							<div class="btn" v-if="item.Status == 0" @click.stop="cancelOrder(item)">{{ $t('trade.status3') }}</div>
						</div>
					</div>
				</div>
			</div>

			<!--金融-->
			<div class="list-table clear-bg mini" v-if="tabIndex == 6">
				<div class="th-line flex-center-between">
					<div class="th flex-2">{{ $t('jiao-yi-bi-zhong-0') }}</div>
					<div class="th flex-2">{{ $t('followDetail.label15') }}</div>
					<div class="th flex-2">{{ $t('follow.label17') }}</div>
					<div class="th flex-2">{{ $t('jiao-yi-shi-jian') }}</div>
					<div class="th flex-2">{{ $t('shou-yi-bi-li') }}</div>
					<div class="th action">{{ $t('finance.label12') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in orderList" :key="i" >
						<div class="td flex-2 flex-center-start">
							<img :src="`/upload/${item.FinancialSetup.Currency.Logo}`" alt="">
							<span>{{item.FinancialSetup.Currency.Name}}</span>
						</div>
						<div class="td flex-2">{{item.FinancialSetup.ProductType === 1 ? $t('finance.label13') : $t('finance.label14')}}</div>
						<div class="td flex-2">
							{{parseFloat(item.OrderAmount).toFixed(2)}}
						</div>
						<div class="td flex-2">
							{{item.CreatedAt}}
						</div>
						<div class="td flex-2">{{item.FinancialSetup.IncomeRatio}}%</div>
						<div class="td action flex-center">
							<span class="green status">{{$t(`finance.tab${item.Status + 3}`)}}</span>
						</div>
					</div>
				</div>
			</div>

			<!--跟单-->
			<div class="list-table clear-bg mini" v-if="tabIndex == 7">
				<div class="th-line flex-center-between">
					<div class="th flex-2" >{{ $t('gen-dan-jiao-yi-yuan') }}</div>
					<div class="th flex-2">{{ $t('tradeFollow.label12') }}</div>
					<div class="th flex-2">{{ $t('gen-dan-jineusdt') }}</div>
					<div class="th flex-2">{{ $t('gen-dan-shi-jian') }}</div>
					<div class="th flex-2">{{ $t('followDetail.label14') }}</div>
					<div class="th action">{{ $t('finance.label12') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in orderList" :key="i" >
						<div class="td flex-2 flex-center-start">
							test01@qq.com
						</div>
						<div class="td flex-2">{{ $t('followDetail.label16') }}</div>
						<div class="td flex-2">
							{{parseFloat(item.OrderAmount).toFixed(2)}}
						</div>
						<div class="td flex-2">
							{{item.CreatedAt}}
						</div>
						<div class="td flex-2">{{item.Profit}}</div>
						<div class="td action flex-center">
							<span class="green ">{{ $t('gen-dan-zhong') }}</span>
						</div>
					</div>
				</div>
			</div>
		</template>

		<div class="" v-if="tabActive == 3">
			<div class="list-table clear-bg mini" >
				<div class="th-line flex-center-between">
					<div class="th flex-2">{{ $t('followDetail.label15') }}</div>
					<div class="th flex-2">{{ $t('follow.label17') }}</div>
					<div class="th flex-2">{{ $t('jiao-yi-fang-xiang') }}</div>
					<div class="th flex-2">{{ $t('jiao-yi-shi-jian') }}</div>
					<div class="th action long text-right">{{ $t('jiao-yi-hou-jineusdt') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in logList" :key="i" >
						<div class="td flex-2 flex-center-start">
							{{getName()}}
						</div>
						<div class="td flex-2">{{item.Practical}}</div>
						<div class="td flex-2">{{getTypeName(item, item.Currency.ShortName) }}</div>
						<div class="td flex-2">{{item.CreatedAt}}</div>
						<div class="td action long text-right">
							{{item.DebtAfter}}
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="list-table clear-bg mini" v-if="tabIndex == 1">
				<div class="th-line flex-center-between">
					<div class="th flex-2">{{ $t('jiao-yi-bi-zhong') }}</div>
					<div class="th flex-2">{{ $t('jiao-yi-shi-jian') }}</div>
					<div class="th flex-1 text-right">{{ $t('jiao-yi-hou-jineusdt') }}</div>
				</div>
				<div class="tbody">
					<div class="td-line flex-center-between" v-for="(item, i) in logList" :key="i" >
						<div class="td flex-2 flex-center-start">
							{{item.Currency.ShortName}}
						</div>
						<div class="td flex-2">{{item.CreatedAt}}</div>
						<div class="td flex-2 text-right">
							{{item.SpotUse}}
						</div>
					</div>
				</div>
			</div> -->

		</div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>

	</div>
</template>
<script>
import { List, Button, Popup, Slider } from 'vant'
import pageBar from '@/components/pageBar'
import { debtType, debtLog, wallet } from '@/api/assest'
import { financeList } from '@/api/finance'
import { imitateOptionOrderList, optionOrderList, spotList, cancelSpotOrder, cancelContractOrder, contractList, imitateContractList, contractSpot, contractLiquidation } from '@/api/trade'
import moment from 'moment';
import 'moment-timezone';
export default {
	components: {
		List,
		Button,
		Popup,
		Slider,
		pageBar
	},
  data() {
		return {
			form: {
				bit: '',
				bitName: '',
				tradeType: '',
				startTime: '',
				endTime: '',
				status: '0'
			},
			bitInfo: {},
			tabIndex: 1,
			tabActive: 1,
			closeUrl: require('../../assets/imgs/icon-close.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			orderList: [],
			logList: [],
			isInit: false,
      loading: false,
      finished: false,
			page: {
				page: 1,
				pageSize: 10,
				total: 1
			},
			totalPage: 1,
			inputActive7: false,
			inputActive8: false,
			showOption: false,
			statusName: this.i18n.t('allOrder.status1'),
			statusList: [
				{
					text: this.i18n.t('allOrder.status1'),
					value: ''
				},
				{
					text: this.i18n.t('allOrder.status2'),
					value: '0'
				},
				{
					text: this.i18n.t('allOrder.status3'),
					value: '1'
				},
				{
					text: this.i18n.t('allOrder.status4'),
					value: '2'
				},
			],
			showClearPage: false,
			orderdetailData: {},
			isCancelOrderEnsure: true,
			showEnsureModal: false,
			showWinSetting: false,
			ensureType: '',
			showMultiplePercent: false,
			showWinPercent: false,
			showLosePercent: false,
			ensureParam: {},
			winData: {},
			winForm: {
				tradeType: 'buy',
				winMoney: '',
				loseMoney: '',
				winPercent: 10,
				losePercent: 10
			},
			multiplePercent: 0,
			winPercent: 0,
			losePercent: 0,
			dataTotal: 0,
			moneySpace: 0.01, // 每次增减金额
			allSpotLog: [],
			tradeFunList: [
				{
					label: this.$t('withdraw.label6'),
					value: ''
				},
				{
					label: this.$t('assestLog.order'),
					value: '1'
				},
				{
					label: this.$t('assestLog.Sell'),
					value: '2'
				},
			],
			pageTypeList: [
        {
          value: '2',
          label: this.$t('pageTitle.account1')
        },
        {
          value: '3',
          label: this.$t('pageTitle.account2')
        },
        {
          value: '1',
          label: this.$t('pageTitle.account3')
        },
        {
          value: '6',
          label: this.$t('pageTitle.account4')
        },
        {
          value: '7',
          label: this.$t('pageTitle.account6')
        },
      ]
		}
	},
	computed: {
		bitList() {
			return [
				{
					ShortName: this.$t('withdraw.label6'),
					ID: ''
				},
				...this.$store.state.bitList
			]
		}
	},
	mounted() {
		this.tabIndex = parseInt(this.$route.query.type || 1) // 4 模拟期权； 5 模拟合约 ; 6、金融订单； 7、跟单订单
		this.initOrder()
		this.initType()
		this.bitInfo = JSON.parse(sessionStorage.getItem('bitInfo'))
		if (this.bitInfo) {
			this.bitInfo.count = parseFloat(this.bitInfo.count)
		}
		if (this.tabActive == 1) {
			this.initSpot()
		}
		if (this.tabIndex == 2 || this.tabIndex == 4) {
			this.startCountdownTimer()
		}
	},
	beforeUnmount() {
		if (this.countdownTimer) {
			clearInterval(this.countdownTimer);
			this.countdownTimer = null;
		}
	},
	methods: {
		initType() {
      debtType().then(res => {
        let data = res.data
        let list = [ ]
        for (let key in data) {
          let param = {
            value: key,
            label: data[key]
          }
          list.push(param)
        }
        this.typeList = list
				if (this.tabActive == 3) {
					if (this.tabIndex == 1) {
						this.initSpotLog()
					} else {
						this.initLog()
					}
				}
      })
    },
		initLog() {
      let form = new FormData()
      let type = ''
      let multiType = ''
      switch (this.tabIndex + '') {
        case '1': type = 'Spot'; multiType = '2,3,6,7,8'; break;
        case '2': type = 'Option'; multiType = '2,3,9,10,11'; break;
        case '3': type = 'Contract'; multiType = '2,3,12,13,14,15,21,22,23,24,25'; break;
        case '6': type = 'Finance'; multiType = '2,3,5,16,33'; break; // 金融
        case '7': type = 'Follow'; multiType = '2,3,9,10,1112,13,14,15,21,22,23,24,25'; break; // 跟单
        default: break;
      }
      form.append('current', this.page.page)
      form.append('limit', this.page.pageSize)
      form.append('CurrencyType', type)
      form.append('Type', '')
      form.append('MultiType', multiType)
      form.append('CurrencyId', this.form.bit)
      debtLog(form).then(res => {
        if (res.data.Items) {
          this.logList = res.data.Items
          this.page.total = res.data.Pagination.totalRecords
        }
      })
    },
		initSpot() {
			let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 100)
      form.append('ShortName', '')
      wallet(form).then(res => {
        if (res.data.Items) {
          this.allSpotLog = res.data.Items.filter(v => {
						return parseFloat(v.SpotUse) > 0
					})

        }
			})
		},
		initSpotLog() {
			this.initLog()
			return
			this.logList = this.allSpotLog.slice(10 * (this.page.page - 1), 10 * this.page.page)
			this.page.total = this.allSpotLog.length
		},
		back() {
			this.$router.go(-1)
		},
		changeTab(i) {
			this.tabActive = i
			this.form.status = i == 1 ? '0' : '1'
			this.page.page = 1
			this.orderList = []
			this.logList = []
			if (this.tabActive == 3) {
				if (this.tabIndex == 1) {
					this.initSpotLog()
				} else {
					this.initLog()
				}
			} else {
				this.initOrder()
			}
		},
		changePage(page) {
      this.page.page = page
			if (this.tabActive == 3) {
				if (this.tabIndex == 1) {
					this.initSpotLog()
				} else {
					this.initLog()
				}
			} else {
				this.initOrder()
			}
    },
		initOrder() {
			let form = new FormData()
			form.append('current', this.page.page)
			form.append('pageSize', this.page.pageSize)
			form.append('status', this.form.status)
			if (this.tabIndex == 1) {// 现货
				spotList(form).then(res => {
					if (res.data.Items) {
						this.orderList = res.data.Items
						this.page.total = res.data.Pagination.totalRecords
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
					}
				})
			} else if (this.tabIndex == 3) {// 合约
				contractList(form).then(res => {
					if (res.data.Items) {
						this.orderList = res.data.Items
						this.page.total = res.data.Pagination.totalRecords
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
					}
				})
			} else if (this.tabIndex == 2) { // 期权
				optionOrderList(form).then(res => {
					if (res.data.Items) {
						this.orderList = res.data.Items
						this.page.total = res.data.Pagination.totalRecords
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
					}
				})
			} else if (this.tabIndex == 4) { // 模拟期权
				imitateOptionOrderList(form).then(res => {
					if (res.data.Items) {
						this.orderList = res.data.Items
						this.page.total = res.data.Pagination.totalRecords
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
					}
				})
			} else if (this.tabIndex == 5) { // 模拟合约

				imitateContractList(form).then(res => {
					if (res.data.Items) {
						this.orderList = res.data.Items
						this.page.total = res.data.Pagination.totalRecords
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
					}
				})
			} else if (this.tabIndex == 6) { // 金融
				financeList(form).then(res => {
					if (res.data.Items) {
						this.orderList = res.data.Items
						this.page.total = res.data.Pagination.totalRecords
						if (this.tabActive == 1) {
							this.dataTotal = res.data.Pagination.totalRecords
						}
					}
				})
			}
		},
		ensureAction() {
			this.showEnsureModal = false
			if (this.ensureType == 'cancel') {
				this.cancelOrder(this.ensureParam)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			} else if (this.ensureType == 'cancelContract') {
				this.doCancelContract(this.ensureParam)
			}
		},
		cancelOrder(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelSpotOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		changeOption(data) {
			this.form.status = data.value
			this.statusName = data.text
			this.page.page = 1
			this.showOption = false
			this.initOrder()
		},
		chooseOption() {
			this.showOption = !this.showOption
		},
		toClearOrder(data) {
			return
			this.orderdetailData = data
			this.showClearPage = true
		},
		cancel() {
			this.showClearPage = false
			this.showEnsureModal = false
			this.showWinSetting = false
		},
		submitClear(data) {
			let form = new FormData()
			form.append('ID', this.orderdetailData.ID)
			form.append('PlanTrust', data.type == 1 ? 'market' : 'limit')
			form.append('PlanTrustNum', data.number)
			form.append('PlanTrustPrice', data.price)
			contractLiquidation(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success3'))
					this.showClearPage = false
					this.page.page = 1
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		cancelContract(data) {
			this.showEnsureModal = true
			this.ensureParam = data
			this.ensureType = 'cancelContract'
		},
		doCancelContract(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelContractOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		//设置止盈止损
		setWinOrLose(data) {
			return
			this.showWinSetting = true
			this.winData = data
			this.winForm.winMoney = data.TakeProfit ? data.TakeProfit.toFixed(this.maxSize) : ''
			this.winForm.loseMoney = data.StopLoss ? data.StopLoss.toFixed(this.maxSize) : ''
		},
		ensureWin() {
			//更改止盈止损价格
			let form = new FormData()
			form.append('ID', this.winData.ID)
			form.append('TakeProfit', this.winForm.winMoney)
			form.append('StopLoss', this.winForm.loseMoney)
			contractSpot(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success3'))
					this.initOrder()
					this.showWinSetting = false
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		changeWinPercent(val) {
			this.winPercent = val / 1.5
			this.changePercent(val, 1)
		},
		changeLosePercent(val) {
			this.losePercent = val / 0.9
			this.changePercent(val, 2)
		},
		changePercent(val, type) {
			if (type == 1) {
				this.winForm.winPercent = val
				this.winPercent = this.winForm.winPercent / 1.5
				this.winForm.winMoney = (this.bitInfo.count * (1 + val / 100)).toFixed(this.maxSize)
			} else {
				this.winForm.losePercent = val
				this.losePercent = this.winForm.losePercent / 0.9
				this.winForm.loseMoney = (this.bitInfo.count * (1 - val / 100)).toFixed(this.maxSize)
			}
		},
		dragWinStart() {
			this.showWinPercent = true
		},
		dragWinEnd() {
			this.showWinPercent = false
		},
		dragLoseStart() {
			this.showLosePercent = true
		},
		dragLoseEnd() {
			this.showLosePercent = false
		},
		checkWinMoney(type) {

			if (type == 1) {
				this.inputActive7 = false
				let newMoney = parseFloat(this.winForm.winMoney)
				this.winForm.winMoney = parseFloat((newMoney).toFixed(this.maxSize))
				if (this.winForm.winMoney < this.bitInfo.count) {
					this.winForm.winMoney = this.bitInfo.count
				}
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				this.inputActive8 = false
				let newMoney = parseFloat(this.winForm.loseMoney)
				this.winForm.loseMoney = parseFloat((newMoney).toFixed(this.maxSize))
				if (this.winForm.loseMoney > this.bitInfo.count) {
					this.winForm.loseMoney = this.bitInfo.count
				}
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		addWinMoney(type) {
			if (type == 1) {
				let newMoney = this.moneySpace + parseFloat(this.winForm.winMoney) || 0
				this.winForm.winMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				let newMoney = this.moneySpace + parseFloat(this.winForm.loseMoney) || 0
				this.winForm.loseMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				if (this.winForm.loseMoney > this.bitInfo.count) {
					this.winForm.loseMoney = this.bitInfo.count
				}
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		minusWinMoney(type) {
			if (type == 1) {
				let newMoney =  parseFloat(this.winForm.winMoney) - this.moneySpace || 0
				if (newMoney < 0) {
					newMoney = 0
				}
				this.winForm.winMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				if (this.winForm.winMoney < this.bitInfo.count) {
					this.winForm.winMoney = this.bitInfo.count
				}
				this.winForm.winPercent = (this.winForm.winMoney - this.bitInfo.count) / this.bitInfo.count * 100
				this.winPercent = this.winForm.winPercent / 1.5
			} else {
				let newMoney =  parseFloat(this.winForm.loseMoney) - this.moneySpace || 0
				if (newMoney < 0) {
					newMoney = 0
				}
				this.winForm.loseMoney = parseFloat(newMoney.toFixed(2)).toFixed(2)
				this.winForm.losePercent = (this.bitInfo.count - this.winForm.loseMoney) / this.bitInfo.count * 100
				this.losePercent = this.winForm.losePercent / 0.9
			}
		},
		toDetail(data) {
			sessionStorage.setItem('orderDetailData', JSON.stringify(data))
			this.$router.push({
				name: 'orderDetail',
				query: {
					type: this.tabIndex
				}
			})
		},
		getContractClose(close, multiple, type) {
			if (type == 'long') {
				return parseFloat((close * (1 - 1 / multiple)).toFixed(4))
			} else {
				return parseFloat((close * (1 + 1 / multiple)).toFixed(4))
			}
		},
		getName() {
      let index = this.pageTypeList.findIndex(v => {
        return v.value == this.tabIndex
      })
      if (index > -1) {
        return this.pageTypeList[index].label
      } else {
        return ''
      }
    },
		getTypeName(item, name) {
      let type = item.Type
      let index = this.typeList.findIndex(v => {
        return v.value == type
      })
      if (index > -1) {
        if (type == 9) {
          return this.i18n.t('assestLog.order') + "(" + name + ")"
        } else if (type == 6) {
          return this.i18n.t('assestLog.order') + "(" + item.Digest + ")"
        } else if (type == 7) {
          return this.i18n.t('assestLog.Sell') + "(" + item.Digest + ")"
        } else if (type == 11) {
          return this.i18n.t('assestLog.Settle') + "(" + name + ")"
        } else {
          return this.typeList[index].label+ "(" + name + ")"
        }
      } else {
        return name
      }
    },
		getCountdownTime(item) {
			// 检查Settlement是否为有效数值
			const settlement = parseInt(item.Settlement, 10);
			if (isNaN(settlement) || settlement <= 0) {
				return '0S';
			}

			try {
				// 获取服务器时区，默认为 Asia/Shanghai
				const serverTimezone = this.$store.state.timeZone || 'Asia/Shanghai';
				
				// 创建服务器时间（服务器返回的时间是服务器时区的时间）
				const createdAt = moment.tz(item.CreatedAt, serverTimezone);
				// 获取当前服务器时区的时间
				const currentTime = moment.tz(serverTimezone);

				// 检查创建时间是否有效
				if (!createdAt.isValid()) {
					return '0S';
				}

				// 计算已经过的秒数（使用服务器时区统一计算）
				const elapsedSeconds = Math.floor(currentTime.diff(createdAt) / 1000);

				// 如果已过时间为负数，则返回完整时间
				if (elapsedSeconds < 0) {
					return settlement + 'S';
				}

				// 计算剩余秒数
				const remainingSeconds = settlement - elapsedSeconds;

				// 确保不小于0
				return Math.max(0, remainingSeconds) + 'S';
			} catch (error) {
				return '0S';
			}
		},
		startCountdownTimer() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
			}
			
			this.countdownTimer = setInterval(() => {
				if (this.tabIndex == 2 || this.tabIndex == 4) {
					this.$forceUpdate();
				}
			}, 1000);
		},
	}
}
</script>